var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { GradientView } from '../gradient-view';
import { getCardProps, getCardStyles } from './CardStyles';
export var Card = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var cardProps = getCardProps(props, stateContext);
  var style = cardProps.style,
    children = cardProps.children,
    _cardProps$testID = cardProps.testID,
    testID = _cardProps$testID === void 0 ? 'Card' : _cardProps$testID,
    _cardProps$showGradie = cardProps.showGradientBorder,
    showGradientBorder = _cardProps$showGradie === void 0 ? false : _cardProps$showGradie,
    gradientContainerStyle = cardProps.gradientContainerStyle,
    restProps = __rest(cardProps, ["style", "children", "testID", "showGradientBorder", "gradientContainerStyle"]);
  var cardStyles = getCardStyles(cardProps, showGradientBorder);
  if (showGradientBorder) {
    return _jsx(GradientView, Object.assign({
      ref: ref,
      type: "RETRO"
    }, restProps, {
      style: [cardStyles.gradientContainer, gradientContainerStyle]
    }, getTestId(testID), {
      children: _jsx(View, Object.assign({
        style: [cardStyles.container, style]
      }, {
        children: children
      }))
    }));
  }
  return _jsx(View, Object.assign({
    ref: ref
  }, restProps, {
    style: [cardStyles.container, style]
  }, getTestId(testID), {
    children: children
  }));
});